/* eslint-disable react/destructuring-assignment */
import React from 'react';

export const PhoneIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="18"
      viewBox="0 0 12 20"
      className={props.className}
      data-palette="PhoneIcon">
      <g fill="none" fillRule="evenodd">
        <g fill="var(--main-text-primary)" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M10.605 0h-9.21C.628 0 0 .627 0 1.395v16.866c0 .768.628 1.396 1.395 1.396h9.21c.767 0 1.395-.627 1.395-1.395V1.395C12 .627 11.372 0 10.605 0zM4.527 1.006h2.946c.093 0 .169.075.169.17 0 .092-.076.168-.169.168H4.527c-.093 0-.169-.076-.169-.169 0-.094.076-.17.169-.17zM6 18.959c-.385 0-.698-.312-.698-.698 0-.386.313-.697.698-.697.385 0 .698.311.698.697 0 .386-.313.698-.698.698zm5.03-1.884H.97V2.213h10.06v14.862z"
                transform="translate(-1361 -15) translate(1171 11) translate(190 4)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const SettingsIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="SettingsIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L24 0 24 24 0 24z"
                transform="translate(-1309 -13) translate(1055 7) translate(254 6)"
              />
              <path
                fill="currentColor"
                fillRule="nonzero"
                d="M12 1l9.5 5.5v11L12 23l-9.5-5.5v-11L12 1zm0 2.311L4.5 7.653v8.694l7.5 4.342 7.5-4.342V7.653L12 3.311zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-2c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z"
                transform="translate(-1309 -13) translate(1055 7) translate(254 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const HeaderWalletIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 22 22"
      className={props.className}
      data-palette="HeaderWalletIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L22 0 22 22 0 22z"
                transform="translate(-1163 -14) translate(1055 7) translate(108 7)"
              />
              <path
                fill="var(--main-text-primary)"
                fillRule="nonzero"
                d="M16.5 6.417h2.75c.506 0 .917.41.917.916v11c0 .507-.41.917-.917.917H2.75c-.506 0-.917-.41-.917-.917V3.667c0-.507.41-.917.917-.917H16.5v3.667zM3.667 8.25v9.167h14.666V8.25H3.667zm0-3.667v1.834h11V4.583h-11zm10.083 7.334h2.75v1.833h-2.75v-1.833z"
                transform="translate(-1163 -14) translate(1055 7) translate(108 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const BonusOfferIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="20"
      fill="none"
      viewBox="0 0 77 20"
      {...props}
      data-palette="BonusOfferIcon">
      <path
        fill="url(#paint0_linear)"
        d="M4.306 3a3 3 0 013-3H74a3 3 0 013 3v14a3 3 0 01-3 3H7.306a3 3 0 01-3-3v-3.893L1.16 10.913a1 1 0 01-.01-1.633l3.156-2.262V3z"></path>
      <path
        fill="#17232E"
        d="M12.663 9.622c.52.161.939.315 1.254.462.323.147.594.37.814.671.227.293.341.686.341 1.177 0 .381-.099.737-.297 1.067-.19.323-.48.583-.869.781-.389.198-.865.297-1.43.297h-.022v.88h-.374v-.902c-.726-.059-1.32-.286-1.782-.682a2.2 2.2 0 01-.77-1.529h1.342c.03.286.147.546.352.781.213.235.499.381.858.44v-2.497a15.491 15.491 0 01-1.375-.473 2.228 2.228 0 01-.836-.66c-.242-.3-.363-.704-.363-1.21 0-.41.106-.774.319-1.089a2.18 2.18 0 01.913-.737c.389-.176.836-.264 1.342-.264V5.2h.374v.946c.719.051 1.29.264 1.716.638.425.374.671.847.737 1.419h-1.353a1.228 1.228 0 00-.352-.682c-.183-.198-.433-.326-.748-.385v2.42l.209.066zm-1.815-1.441c0 .323.106.58.319.77.213.183.517.345.913.484V7.103c-.381.007-.682.106-.902.297-.22.183-.33.444-.33.781zm1.606 4.917c.403 0 .715-.106.935-.319.227-.213.341-.484.341-.814 0-.337-.11-.598-.33-.781-.22-.19-.535-.356-.946-.495v2.409zm6.41-7.106c.513 0 .953.092 1.32.275.366.176.641.422.825.737.19.315.285.667.285 1.056 0 .491-.139.902-.418 1.232-.27.323-.656.517-1.155.583v.055c.536.154.954.385 1.255.693.308.3.462.719.462 1.254 0 .653-.217 1.184-.65 1.595-.432.403-1.052.605-1.858.605-.83 0-1.497-.209-2.003-.627-.505-.425-.795-1.052-.869-1.881h1.244c.044.44.201.792.473 1.056.27.257.638.385 1.1.385.432 0 .762-.114.99-.341.234-.227.352-.52.352-.88 0-.433-.17-.763-.506-.99-.33-.227-.81-.341-1.441-.341h-.297V9.424h.297c1.195.015 1.793-.392 1.793-1.221 0-.36-.11-.642-.33-.847-.22-.205-.521-.308-.902-.308-.382 0-.7.117-.957.352-.257.227-.411.561-.462 1.001H16.18c.05-.763.308-1.353.77-1.771.462-.425 1.1-.638 1.913-.638zm3.803 4.07c0 1.24.22 2.211.66 2.915.44.697 1.173 1.045 2.2 1.045 1.026 0 1.76-.352 2.2-1.056.44-.704.66-1.672.66-2.904 0-1.225-.22-2.185-.66-2.882-.44-.704-1.174-1.056-2.2-1.056-1.027 0-1.76.348-2.2 1.045-.44.697-.66 1.661-.66 2.893zm4.466 0c0 .895-.11 1.58-.33 2.057-.22.477-.646.715-1.276.715-.638 0-1.067-.238-1.287-.715-.22-.477-.33-1.162-.33-2.057 0-.887.11-1.566.33-2.035.22-.47.649-.704 1.287-.704.63 0 1.056.238 1.276.715.22.47.33 1.144.33 2.024zm5.005.011L35.56 14H34.03l-3.069-3.597V14h-1.254V6.234h1.254v3.553l3.08-3.553h1.518l-3.42 3.839zm10.984-.077c.47.095.847.319 1.133.671.294.352.44.763.44 1.232 0 .645-.216 1.159-.649 1.54-.432.374-1.06.561-1.88.561h-3.092V6.234h3.036c.778 0 1.372.176 1.782.528.418.345.627.821.627 1.43 0 .491-.128.891-.385 1.199a1.88 1.88 0 01-1.012.605zm-2.794-.418h1.551c.44 0 .774-.103 1.001-.308.235-.205.352-.491.352-.858 0-.36-.117-.642-.352-.847-.227-.205-.575-.308-1.045-.308h-1.507v2.321zm1.584 3.388c.477 0 .844-.106 1.1-.319.264-.22.396-.524.396-.913s-.132-.693-.396-.913c-.264-.22-.634-.33-1.11-.33h-1.574v2.475h1.584zm6.734-5.104c.587 0 1.115.125 1.584.374.47.25.836.609 1.1 1.078.264.47.396 1.02.396 1.65 0 .638-.132 1.192-.396 1.661-.264.47-.63.829-1.1 1.078-.47.25-.997.374-1.584.374a3.324 3.324 0 01-1.584-.374 2.776 2.776 0 01-1.1-1.078c-.264-.477-.396-1.03-.396-1.661 0-.63.132-1.18.396-1.65.272-.47.638-.829 1.1-1.078.47-.25.998-.374 1.584-.374zm0 1.089c-.322 0-.62.073-.89.22a1.648 1.648 0 00-.66.682c-.162.3-.243.671-.243 1.111 0 .447.08.821.242 1.122.169.3.389.524.66.671.272.147.569.22.891.22.323 0 .62-.073.891-.22.272-.147.488-.37.65-.671.168-.3.252-.675.252-1.122 0-.44-.084-.81-.253-1.111a1.581 1.581 0 00-.649-.682 1.843 1.843 0 00-.89-.22zM56.32 7.84c.704 0 1.269.227 1.694.682.425.455.638 1.104.638 1.947V14h-1.254v-3.399c0-.543-.14-.96-.418-1.254-.279-.3-.66-.451-1.144-.451-.499 0-.898.161-1.2.484-.3.315-.45.781-.45 1.397V14h-1.254V7.939h1.254V9.27c.161-.455.432-.807.814-1.056.381-.25.821-.374 1.32-.374zm9.386.099V14h-1.265v-1.32a1.98 1.98 0 01-.803 1.045c-.381.242-.825.363-1.33.363-.705 0-1.27-.227-1.695-.682-.425-.455-.638-1.104-.638-1.947v-3.52h1.254v3.388c0 .55.14.975.418 1.276.279.293.66.44 1.144.44.499 0 .899-.161 1.2-.484.3-.323.45-.792.45-1.408V7.939h1.265zm3.493-.077c.712 0 1.28.183 1.705.55.433.36.697.843.792 1.452h-1.188a1.248 1.248 0 00-.429-.792c-.227-.205-.531-.308-.913-.308-.315 0-.56.077-.737.231-.168.147-.253.348-.253.605 0 .19.063.345.187.462.125.117.279.209.462.275.19.066.459.14.803.22.455.103.822.209 1.1.319.286.11.528.286.726.528.206.235.308.557.308.968 0 .506-.194.917-.583 1.232-.381.315-.898.473-1.55.473-.756 0-1.368-.176-1.838-.528-.462-.352-.74-.843-.836-1.474h1.221c.037.33.184.598.44.803.257.205.594.308 1.012.308.3 0 .536-.077.704-.231a.787.787 0 00.264-.605.663.663 0 00-.198-.506 1.313 1.313 0 00-.495-.286 6.101 6.101 0 00-.814-.22c-.44-.103-.8-.205-1.078-.308a1.74 1.74 0 01-.704-.495c-.19-.235-.286-.55-.286-.946 0-.513.19-.928.572-1.243.389-.323.924-.484 1.606-.484z"></path>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0"
          x2="0"
          y1="0"
          y2="20"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE633"></stop>
          <stop offset="1" stopColor="#FCCB18"></stop>
        </linearGradient>
      </defs>
    </svg>)
  );
};

export const ThreeDots = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="ThreeDots">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L24 0 24 24 0 24z"
                transform="translate(-1397 -13) translate(1055 7) translate(342 6)"
              />
              <path
                fill="var(--main-text-primary)"
                fillRule="nonzero"
                d="M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                transform="translate(-1397 -13) translate(1055 7) translate(342 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const DetoCompetitionOfferIcon = props => {
  return (
    (<svg
      width="64"
      height="20"
      viewBox="0 0 64 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      data-palette="DetoCompetitionOfferIcon">
      <path
        d="M4.27273 3C4.27273 1.34315 5.61587 0 7.27273 0H60.5C62.1569 0 63.5 1.34315 63.5 3V17C63.5 18.6569 62.1569 20 60.5 20H7.27273C5.61587 20 4.27273 18.6569 4.27273 17V13.107L1.14834 10.9113C0.586124 10.5162 0.580747 9.6848 1.13781 9.28245L4.27273 7.01818V3Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M19.093 6.234L17.157 14H15.617L13.978 7.994L12.339 14H10.799L8.863 6.234H10.238L11.58 12.548L13.285 6.234H14.671L16.376 12.548L17.718 6.234H19.093ZM20.04 6.179C20.04 5.96633 20.1134 5.79033 20.26 5.651C20.4067 5.51167 20.601 5.442 20.843 5.442C21.085 5.442 21.2794 5.51167 21.426 5.651C21.58 5.79033 21.657 5.96633 21.657 6.179C21.657 6.39167 21.58 6.564 21.426 6.696C21.2794 6.828 21.085 6.894 20.843 6.894C20.601 6.894 20.4067 6.828 20.26 6.696C20.1134 6.564 20.04 6.39167 20.04 6.179ZM21.47 7.939V14H20.216V7.939H21.47ZM26.3755 7.84C27.0795 7.84 27.6442 8.06733 28.0695 8.522C28.4948 8.97667 28.7075 9.62567 28.7075 10.469V14H27.4535V10.601C27.4535 10.0583 27.3142 9.64033 27.0355 9.347C26.7568 9.04633 26.3755 8.896 25.8915 8.896C25.3928 8.896 24.9932 9.05733 24.6925 9.38C24.3918 9.69533 24.2415 10.161 24.2415 10.777V14H22.9875V7.939H24.2415V9.27C24.4028 8.81533 24.6742 8.46333 25.0555 8.214C25.4368 7.96467 25.8768 7.84 26.3755 7.84ZM35.6562 9.622C36.1768 9.78333 36.5948 9.93733 36.9102 10.084C37.2328 10.2307 37.5042 10.4543 37.7242 10.755C37.9515 11.0483 38.0652 11.4407 38.0652 11.932C38.0652 12.3133 37.9662 12.669 37.7682 12.999C37.5775 13.3217 37.2878 13.582 36.8992 13.78C36.5105 13.978 36.0338 14.077 35.4692 14.077H35.4472V14.957H35.0732V14.055C34.3472 13.9963 33.7532 13.769 33.2912 13.373C32.8292 12.9697 32.5725 12.46 32.5212 11.844H33.8632C33.8925 12.13 34.0098 12.3903 34.2152 12.625C34.4278 12.8597 34.7138 13.0063 35.0732 13.065V10.568C34.4718 10.3847 34.0135 10.227 33.6982 10.095C33.3828 9.95567 33.1042 9.73567 32.8622 9.435C32.6202 9.13433 32.4992 8.731 32.4992 8.225C32.4992 7.81433 32.6055 7.45133 32.8182 7.136C33.0382 6.82067 33.3425 6.575 33.7312 6.399C34.1198 6.223 34.5672 6.135 35.0732 6.135V5.2H35.4472V6.146C36.1658 6.19733 36.7378 6.41 37.1632 6.784C37.5885 7.158 37.8342 7.631 37.9002 8.203H36.5472C36.5032 7.939 36.3858 7.71167 36.1952 7.521C36.0118 7.323 35.7625 7.19467 35.4472 7.136V9.556L35.6562 9.622ZM33.8412 8.181C33.8412 8.50367 33.9475 8.76033 34.1602 8.951C34.3728 9.13433 34.6772 9.29567 35.0732 9.435V7.103C34.6918 7.11033 34.3912 7.20933 34.1712 7.4C33.9512 7.58333 33.8412 7.84367 33.8412 8.181ZM35.4472 13.098C35.8505 13.098 36.1622 12.9917 36.3822 12.779C36.6095 12.5663 36.7232 12.295 36.7232 11.965C36.7232 11.6277 36.6132 11.3673 36.3932 11.184C36.1732 10.9933 35.8578 10.8283 35.4472 10.689V13.098ZM38.9966 13.021C40.1846 12.207 41.1343 11.4113 41.8456 10.634C42.5643 9.84933 42.9236 9.12333 42.9236 8.456C42.9236 8.06 42.8246 7.74467 42.6266 7.51C42.436 7.27533 42.1243 7.158 41.6916 7.158C41.2443 7.158 40.907 7.30467 40.6796 7.598C40.4523 7.884 40.324 8.29467 40.2946 8.83H39.0736C39.125 7.94267 39.3963 7.26433 39.8876 6.795C40.3863 6.32567 41.0206 6.091 41.7906 6.091C42.546 6.091 43.1363 6.29267 43.5616 6.696C43.9943 7.092 44.2106 7.642 44.2106 8.346C44.2106 8.91067 44.0346 9.48267 43.6826 10.062C43.338 10.6413 42.898 11.1767 42.3626 11.668C41.8273 12.152 41.2736 12.57 40.7016 12.922H44.3866V13.945H38.9966V13.021ZM50.7489 7.224H46.9099V9.534C47.0859 9.30667 47.3352 9.127 47.6579 8.995C47.9805 8.85567 48.3362 8.786 48.7249 8.786C49.2675 8.786 49.7185 8.90333 50.0779 9.138C50.4372 9.36533 50.7012 9.66967 50.8699 10.051C51.0459 10.4323 51.1339 10.854 51.1339 11.316C51.1339 12.13 50.9065 12.79 50.4519 13.296C49.9972 13.7947 49.3372 14.044 48.4719 14.044C47.6579 14.044 47.0015 13.8277 46.5029 13.395C46.0042 12.9623 45.7329 12.3867 45.6889 11.668H46.9209C46.9869 12.064 47.1482 12.3757 47.4049 12.603C47.6689 12.8303 48.0025 12.944 48.4059 12.944C48.9045 12.944 49.2785 12.7937 49.5279 12.493C49.7772 12.1923 49.9019 11.7927 49.9019 11.294C49.9019 10.8247 49.7735 10.458 49.5169 10.194C49.2602 9.92267 48.8935 9.787 48.4169 9.787C48.0795 9.787 47.7825 9.86033 47.5259 10.007C47.2765 10.1537 47.0932 10.348 46.9759 10.59H45.7549V6.113H50.7489V7.224ZM54.8521 10.073L58.2731 14H56.7441L53.6751 10.403V14H52.4211V6.234H53.6751V9.787L56.7551 6.234H58.2731L54.8521 10.073Z"
        fill="#17232E"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0"
          y1="0"
          x2="0"
          y2="20"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE633" />
          <stop offset="1" stopColor="#FCCB18" />
        </linearGradient>
      </defs>
    </svg>)
  );
};

export const RaiseSupportTicket = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      className={props.className}
      data-palette="RaiseSupportTicket">
      <defs>
        <linearGradient
          id="o3p8wh6r9a"
          x1="80.53%"
          x2="17.823%"
          y1="5.672%"
          y2="90.463%">
          <stop offset="0%" stopColor="var(--main-text-secondary)" />
          <stop offset="100%" stopColor="var(--main-text-secondary)" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L22 0 22 22 0 22z"
                  transform="translate(-777 -59) translate(765 30.92) translate(12 29) translate(2 2)"
                />
                <path
                  fill="url(#o3p8wh6r9a)"
                  fillRule="nonzero"
                  d="M19.25 13.973v5.284c0 .503-.408.91-.91.91H3.66c-.243-.002-.475-.1-.646-.273-.17-.173-.266-.407-.264-.65V8.25h5.5c.506 0 .917-.41.917-.917v-5.5h9.168c.505 0 .915.417.915.91v3.45L11 14.444l-.005 3.886 3.893.005 4.362-4.361zM2.75 6.417l4.583-4.58v4.58H2.75z"
                  transform="translate(-777 -59) translate(765 30.92) translate(12 29) translate(2 2)"
                />
                <path
                  fill="var(--main-text-secondary)"
                  fillRule="nonzero"
                  d="M19.963 8.074L21.259 9.37 14.13 16.5 12.832 16.498 12.833 15.204 19.963 8.074z"
                  transform="translate(-777 -59) translate(765 30.92) translate(12 29) translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const Globe = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    className={props.className}
    data-palette="Globe">
    <path fill="#E5E5E5" d="M0 0H20V20H0z"></path>
    <g clipPath="url(#clip0)">
      <path
        fill="#121B23"
        d="M0 0H375V667H0z"
        transform="translate(-16 -63)"></path>
      <g>
        <path fill="var(--main-bg-surface-alt)" d="M-16 -63H359V41H-16z"></path>
        <g>
          <path
            fill="#717782"
            d="M9.37 12.46V13H4.88v-.46l2.53-2.83c.36-.413.62-.777.78-1.09.16-.32.24-.637.24-.95 0-.427-.123-.753-.37-.98-.24-.233-.587-.35-1.04-.35-.7 0-1.383.287-2.05.86l-.26-.49c.28-.273.63-.493 1.05-.66.42-.167.84-.25 1.26-.25.633 0 1.13.167 1.49.5.367.327.55.773.55 1.34 0 .407-.097.803-.29 1.19-.187.387-.493.817-.92 1.29l-2.14 2.34h3.66zm6.246-1.08h-1.1V13h-.62v-1.62h-3.37v-.47l3.48-5.03h.51v4.97h1.1v.53zm-1.72-.53V6.98l-2.68 3.87h2.68zm5.256-2.98c1.207 0 1.81.647 1.81 1.94V13h-.61V9.85c0-.5-.103-.867-.31-1.1-.2-.233-.517-.35-.95-.35-.5 0-.903.153-1.21.46-.306.307-.46.72-.46 1.24V13h-.6V5.64h.6v3.22c.16-.327.39-.573.69-.74.3-.167.647-.25 1.04-.25zm11.97-1.99L28.042 13h-.57l-3.08-7.12h.65l2.72 6.32 2.72-6.32h.64zm2.329 7.19c-.46 0-.867-.107-1.22-.32a2.155 2.155 0 01-.81-.91c-.187-.393-.28-.85-.28-1.37 0-.52.093-.977.28-1.37.193-.393.463-.697.81-.91.353-.213.76-.32 1.22-.32.453 0 .853.107 1.2.32.346.213.613.517.8.91.193.393.29.85.29 1.37 0 .52-.097.977-.29 1.37a2.092 2.092 0 01-.8.91c-.347.213-.747.32-1.2.32zm-.01-.54c.533 0 .943-.177 1.23-.53.293-.36.44-.87.44-1.53 0-.653-.147-1.16-.44-1.52-.294-.367-.7-.55-1.22-.55-.527 0-.937.183-1.23.55-.293.36-.44.867-.44 1.52 0 .667.143 1.177.43 1.53.287.353.697.53 1.23.53zm3.635-6.89h.6V13h-.6V5.64zm2.986 6.49V13h-.85v-.87h.85z"></path>
        </g>
      </g>
      <path fill="var(--main-bg-surface-alt)" d="M-16 -7H359V604H-16z"></path>
      <g>
        <g>
          <g fill="var(--main-text-primary)">
            <mask id="path-4-inside-1">
              <path d="M4.235 4.453a8 8 0 008.817 12.944c.115-.75-.137-1.47-.24-1.722-.23-.56-.988-1.517-2.253-2.844-.338-.355-.316-.628-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756.165.075.37.17.645.325.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034a8.002 8.002 0 00-3.105-12.341c-.553.373-1.312.902-1.577 1.265-.135.185-.327 1.132-.95 1.21-.162.02-.381.006-.613-.009-.622-.04-1.472-.095-1.744.644-.173.468-.203 1.74.356 2.4.09.105.107.3.046.519-.08.287-.241.462-.292.498-.096-.056-.288-.279-.419-.43-.313-.365-.705-.82-1.211-.96-.184-.051-.386-.093-.583-.135-.549-.115-1.17-.246-1.315-.554-.106-.226-.105-.537-.105-.865 0-.417 0-.888-.204-1.345a1.276 1.276 0 00-.306-.43zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"></path>
            </mask>
            <path
              stroke="var(--main-bg-surface-alt)"
              fill="var(--dropdownIconColor)"
              strokeWidth="0.8"
              d="M4.235 4.453a8 8 0 008.817 12.944c.115-.75-.137-1.47-.24-1.722-.23-.56-.988-1.517-2.253-2.844-.338-.355-.316-.628-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756.165.075.37.17.645.325.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034a8.002 8.002 0 00-3.105-12.341c-.553.373-1.312.902-1.577 1.265-.135.185-.327 1.132-.95 1.21-.162.02-.381.006-.613-.009-.622-.04-1.472-.095-1.744.644-.173.468-.203 1.74.356 2.4.09.105.107.3.046.519-.08.287-.241.462-.292.498-.096-.056-.288-.279-.419-.43-.313-.365-.705-.82-1.211-.96-.184-.051-.386-.093-.583-.135-.549-.115-1.17-.246-1.315-.554-.106-.226-.105-.537-.105-.865 0-.417 0-.888-.204-1.345a1.276 1.276 0 00-.306-.43zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"></path>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <path
          fill="var(--main-text-primary)"
          d="M0 0H375V667H0z"
          transform="translate(-16 -63)"></path>
      </clipPath>
    </defs>
  </svg>
);
export const SliderIcon = props => {
  return (
    (<svg
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      data-palette="SliderIcon">
      <path
        d="M4 21V14"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M4 10V3"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M12 21V12"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M12 8V3"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M20 21V16"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M20 12V3"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M1 14H7"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M9 8H15"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M17 16H23"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>)
  );
};
